// Shared copy for /pricing and homepage #pricing

export const BLOOM_FEATURES = [
  'Early Access to New Features',
  'Verified Founding Member Badge',
  'All 4 Chapters — Switch Anytime',
  'Unlimited Nova AI Conversations',
  'Full Journey Tracker & Milestone Alerts',
  'Health Record + Financial Tracker',
  'Community, Live Rooms, Connect',
];

export const ENTERPRISE_FEATURES = [
  'Clinical program integrations',
  'Employer health benefit programs',
  'Health system partnerships',
  'HIPAA BAA available',
  'Dedicated account management',
  'Custom chapter configurations',
];

export const PRICING_FAQ = [
  {
    q: 'Can I be in multiple chapters at once?',
    a: "Yes. That's one of the things that makes OrivonAI different. You can be in Fertility and Motherhood simultaneously — for example, if you're doing fertility treatment for a second child while parenting your first. Both dashboards stay active, and Nova knows which chapter you're in.",
  },
  {
    q: 'Is there a free trial for Bloom?',
    a: "We're opening Bloom in phases — join the waitlist to hear when your spot is ready and about any launch offers. Enterprise partnerships follow a separate timeline for organizations.",
  },
  {
    q: "What does 'no data selling' actually mean?",
    a: "Your health data — cycle logs, IVF results, medications, symptoms, everything — is never sold to employers, insurers, pharmaceutical companies, or advertisers. This is a line we will not cross. Flo and Ovia have crossed it. We won't.",
  },
  {
    q: "What's included in 'all 4 chapters'?",
    a: 'Trying to Conceive (natural TTC), Fertility (IVF, IUI, egg freezing), Pregnancy (week-by-week), and Motherhood (postpartum through teen years). You can join all four.',
  },
  {
    q: 'Can I cancel Bloom anytime?',
    a: 'Yes. Monthly plans cancel with no penalty. Annual plans are refunded prorated if you cancel in the first 30 days. After that, your access continues until the end of the billing year.',
  },
];

export const TRUST_BAR_ITEMS = [
  '✓ HIPAA-aware design',
  '🚫 No ads, ever',
  '🤝 No data selling — not to employers, insurers, or anyone',
  '✕ No freemium bait-and-switch',
];
